const isDirectUrl = (value) =>
  typeof value === "string" && /^(https?:|data:|blob:)/.test(value);

const normalizeSpacesKey = (value, defaultFolder = "survey-images") => {
  if (!value) return null;

  const raw = String(value).replace(/^\/+/, "");
  if (!raw) return null;

  if (isDirectUrl(raw)) return null;

  if (raw.includes("/")) return raw;

  if (!defaultFolder) return raw;
  return `${defaultFolder}/${raw}`;
};

const buildSpacesImageUrl = (value, options = {}) => {
  if (!value) return null;
  if (isDirectUrl(value)) return value;

  const { defaultFolder = "survey-images", redirect = true } = options;
  const key = normalizeSpacesKey(value, defaultFolder);
  if (!key) return null;

  const base = (process.env.REACT_APP_SPACES || "").replace(/\/+$/, "");
  if (!base) return null;

  return `${base}/image/${key}${redirect ? "?redirect=true" : ""}`;
};

export { buildSpacesImageUrl, normalizeSpacesKey };
